<template>
  <div class="dashboard">
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/dorm-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-university"></i>
            <h4>{{ dorms }} Yurt</h4>
            <p>--</p>
            <router-link :to="{ name: 'dorms.list' }" class="btn btn-primary">Yurt Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/user-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-users"></i>
            <h4>{{ users }} Üye</h4>
            <p>--</p>
            <router-link :to="{ name: 'users.list' }" class="btn btn-primary">Üye Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/university-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-university"></i>
            <h4>{{ universities }} Üniversite</h4>
            <p>--</p>
            <router-link
              :to="{ name: 'universities.list' }"
              class="btn btn-primary"
            >Üniversite Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/advert-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-bolt"></i>
            <h4>{{ promotes }} Reklam</h4>
            <p>--</p>
            <router-link :to="{ name: 'promotes.list' }" class="btn btn-primary">Reklam Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/ilanlar-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-newspaper-o"></i>
            <h4>{{ news }} Haber</h4>
            <p>--</p>
            <router-link :to="{ name: 'news.list' }" class="btn btn-primary">Haber Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/page-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-columns"></i>
            <h4>{{ pages }} Sayfa</h4>
            <p>--</p>
            <router-link :to="{ name: 'pages.list' }" class="btn btn-primary">Sayfa Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/page-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-bullhorn"></i>
            <h4>{{ adverts }} İlan</h4>
            <p>--</p>
            <router-link :to="{ name: 'adverts.list' }" class="btn btn-primary">İlan Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/page-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-envelope"></i>
            <h4>{{ contacts }} Ziyaretçi Defteri</h4>
            <p>--</p>
            <router-link :to="{ name: 'contacts.list' }" class="btn btn-primary">Ziyaretçi Listesi</router-link>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4">
        <div class="panel widget center bgimage">
          <img class="bgimage__img" src="@/assets/images/dash-bg/page-bg.jpg" alt>
          <div class="dimmer"></div>
          <div class="panel-content-wrp">
            <i class="fa fa-commenting"></i>
            <h4>{{ messages }} Mesaj</h4>
            <p>--</p>
            <router-link :to="{ name: 'messages.list' }" class="btn btn-primary">Mesaj Listesi</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="table-area">
            <div class="widget-title">
              <h3>Popüler Yurtlar</h3>
              <span>En çok ziyaret edilen yurtlar</span>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Yurt Adı</th>
                    <th>İl / İlçe</th>
                    <th>Görüntülenme</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="popular_dorm in popular_dorms" :key="popular_dorm.id">
                    <td>{{ popular_dorm.name }}</td>
                    <td>{{ popular_dorm.city.name }} / {{ popular_dorm.district.name }} </td>
                    <td>{{ formatPrice(popular_dorm.number_of_views) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="widget">
          <div class="table-area">
            <div class="widget-title">
              <h3>İletişim Formu</h3>
              <span>Okunmamış mesajlar</span>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Ad Soyad</th>
                    <th>IP</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="contact_form in contact_forms" :key="contact_form.id">
                    <td>{{ contact_form.name }}</td>
                    <td>{{ contact_form.ip }}</td>
                    <td>
                      <router-link
                        :to="{ name: 'contacts.show', params: {id: contact_form.id} }"
                        class="btn btn-primary btn-xs"
                      >
               
                        <span>Düzenle</span>
                      </router-link>/
                      <button class="btn btn-danger btn-xs">
                       Sil
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="widget">
          <div class="table-area">
            <div class="widget-title">
              <h3>Şehir Yorumları</h3>
              <span>Okunmamış mesajlar</span>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Başlık</th>
                    <th>Şehir</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="city_comment in city_comments" :key="city_comment.id">
                    <td>{{ city_comment.title }}</td>
                    <td>{{ city_comment.city.name }}</td>
                    <td>
                      <router-link
                        :to="{ name: 'city_comment.show', params: {id: city_comment.id} }"
                        class="btn btn-primary btn-xs"
                      >
                       
                        <span>Düzenle</span>
                      </router-link>/
                      <button class="btn btn-danger btn-xs">
                       Sil
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dorms: "0",
      users: "0",
      universities: "0",
      adverts: "0",
      promotes: "0",
      messages: "0",
      news: "0",
      pages: "0",
      contacts: "0",
      contact_forms: [],
      city_comments: [],
      popular_dorms: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios.get("/").then(response => {
        this.dorms = response.data.dorms;
        this.users = response.data.users;
        this.universities = response.data.universities;
        this.adverts = response.data.adverts;
        this.promotes = response.data.promotes;
        this.messages = response.data.messages;
        this.news = response.data.news;
        this.pages = response.data.pages;
        this.contacts = response.data.contacts;
        this.contact_forms = response.data.contact_forms;
        this.city_comments = response.data.city_comments;
        this.popular_dorms = response.data.popular_dorms;
      });
    },
    formatPrice(value) {
        return value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1'+".");
    }
  }
};
</script>

<style scoped>
.panel.widget.bgimage {
  background-size: cover;
  background-position: center center;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}
.panel.widget.center {
  text-align: center;
}
.panel.widget {
  padding: 30px;
  border: 0;
  border-radius: 3px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.panel.widget .dimmer {
  background: rgba(45, 53, 61, 0.5);
  background: linear-gradient(
    135deg,
    rgba(45, 53, 61, 0.79) 0,
    rgba(45, 53, 61, 0.5) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#c92d353d', endColorstr='#802d353d', GradientType=1 );
  opacity: 1;
  transition: all 0.3s ease;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.panel.widget .panel-content-wrp {
  z-index: 9;
  position: relative;
}
.panel-content-wrp h4 {
  background-color: transparent !important;
}

.panel > :not(.panel-loading):not(.collapsing) {
  transition: opacity 0.3s;
}
.panel.widget i {
  font-size: 48px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: block;
  margin: 0 auto;
  color: #eee;
  line-height: 110px;
}
.voyager-group:before {
  content: "\6b";
}
[class*=" voyager-"]:before,
[class^="voyager-"]:before,
[data-icon]:before {
  font-family: voyager !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-variant: normal !important;
  text-transform: none !important;
  line-height: 1;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.panel.widget h4 {
  color: #fff;
  font-weight: 300;
  margin-top: 20px;
  font-size: 20px;
}
.panel.widget p {
  margin: 30px 0 0;
  font-size: 20px;
  font-size: 14px;
  color: #ddd;
  display: block;
  max-height: 65px;
}

.bgimage__img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>